import { Deferred } from '@helo/utils';
const stateConfigsMatch = (configA) => (configB) => {
    if ('name' in configA && 'name' in configB) {
        return configA.name === configB.name;
    }
    if ('key' in configA && 'key' in configB) {
        return configA.key === configB.key;
    }
    if ('typeName' in configA && 'typeName' in configB) {
        return configA.typeName === configB.typeName;
    }
    return false;
};
const findMatchingStateConfig = (searchList) => (config) => Array.isArray(searchList)
    ? searchList.find(stateConfigsMatch(config))
    : stateConfigsMatch(config)(searchList)
        ? searchList
        : undefined;
const missingStateConfigs = (sourceList, checkForMissingList) => checkForMissingList.filter(item => !sourceList.find(stateConfigsMatch(item)));
const mergeStateConfigs = (configB, mergeFunction) => (configA) => {
    if (Array.isArray(configA)) {
        if (Array.isArray(configB)) {
            const missingConfigs = missingStateConfigs(configA, configB);
            const overwrittenA = configA.map(config => {
                const configBItem = findMatchingStateConfig(configB)(config);
                if (!configBItem) {
                    return config;
                }
                return mergeStateConfigs(configBItem, mergeFunction)(config);
            });
            return [...overwrittenA, ...missingConfigs];
        }
        throw new Error('mergeDataTypeConfigs2: configB is not an array, but configA is.');
    }
    if (Array.isArray(configB)) {
        throw new Error('mergeDataTypeConfigs2: configA is not an array, but configB is.');
    }
    if (stateConfigsMatch(configB)(configA)) {
        const updated = {
            ...configA,
        };
        if ('state' in configA || 'state' in configB) {
            ;
            updated.state = mergeFunction
                ? mergeFunction(configA.state, configB.state)
                : Deferred.merge(configB.state ?? {})(configA.state ?? {});
        }
        if ('fields' in updated && 'fields' in configB) {
            updated.fields = mergeStateConfigs(configB.fields, mergeFunction)(updated.fields);
        }
        if (!('fields' in updated) && 'fields' in configB) {
            ;
            updated.fields = configB.fields;
        }
        if ('possibleTypes' in updated && 'possibleTypes' in configB) {
            updated.possibleTypes = mergeStateConfigs(configB.possibleTypes, mergeFunction)(updated.possibleTypes);
        }
        if (!('possibleTypes' in updated) && 'possibleTypes' in configB) {
            ;
            updated.possibleTypes = configB.possibleTypes;
        }
        if ('ofType' in updated && 'ofType' in configB) {
            updated.ofType = mergeStateConfigs(configB.ofType, mergeFunction)(updated.ofType);
        }
        if (!('ofType' in updated) && 'ofType' in configB) {
            ;
            updated.ofType = configB.ofType;
        }
        if ('items' in updated && 'items' in configB && configB.items) {
            updated.items = mergeStateConfigs(configB.items, mergeFunction)(updated.items);
        }
        if (!('items' in updated) && 'items' in configB) {
            ;
            updated.items = configB.items;
        }
        if ('args' in updated && 'args' in configB) {
            updated.args = mergeStateConfigs(configB.args, mergeFunction)(updated.args);
        }
        if (!('args' in updated) && 'args' in configB) {
            ;
            updated.args = configB.args;
        }
        if ('fields' in updated && 'fields' in configB) {
            updated.fields = mergeStateConfigs(configB.fields, mergeFunction)(updated.fields);
        }
        if (!('fields' in updated) && 'fields' in configB) {
            ;
            updated.fields = configB.fields;
        }
        if ('enumValues' in updated && 'enumValues' in configB) {
            updated.enumValues = mergeStateConfigs(configB.enumValues, mergeFunction)(updated.enumValues);
        }
        if (!('enumValues' in updated) && 'enumValues' in configB) {
            ;
            updated.enumValues = configB.enumValues;
        }
        return updated;
    }
    return configA;
};
export const StateConfigUtils = {
    mergeStateConfigs,
    findMatchingStateConfig,
};
//# sourceMappingURL=StateConfig.utils.js.map